import React from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Demo = ({ content, toastManager }) =>{ 
    
  const notify = () =>{ 
  // toast.success("Success Notification !", {
  //   position: toast.POSITION.TOP_CENTER
  // });

  toast.error("Error Notification !", {
    position: toast.POSITION.TOP_RIGHT,autoClose: false,
  });


};
    return(
    
      <div>
      <button onClick={notify}>Notify !</button>
      <ToastContainer />
    </div>
);}

export default Demo;


// WEBPACK FOOTER //
// ./web/components/common/toaster.js